import { type ReactNode } from "react";
import { Container } from "@/platform/layout/container";

interface PageShellProps {
  kicker?: string;
  title: string;
  description?: ReactNode;
  children?: ReactNode;
  size?: "narrow" | "default" | "wide";
  /** Decorative aside no header, ex.: badge ou stat. */
  aside?: ReactNode;
}

export function PageShell({
  kicker,
  title,
  description,
  children,
  size = "default",
  aside,
}: PageShellProps) {
  return (
    <Container size={size} className="py-16 md:py-24">
      <header className="grid items-end gap-6 md:grid-cols-[1fr_auto] animate-fade-up">
        <div className="max-w-3xl">
          {kicker ? (
            <p className="flex items-center gap-3 text-[length:var(--text-overline)] uppercase tracking-[var(--text-overline--letter-spacing)] text-[color:var(--color-muted-foreground)]">
              <span aria-hidden className="inline-block h-px w-8 bg-[color:var(--color-border)]" />
              {kicker}
            </p>
          ) : null}
          <h1 className="mt-4 font-display text-[length:var(--text-display-lg)] font-semibold leading-[var(--text-display-lg--line-height)] tracking-[var(--text-display-lg--letter-spacing)] text-balance">
            {title}
          </h1>
          {description ? (
            <div className="mt-5 text-[length:var(--text-body-lg)] text-[color:var(--color-muted-foreground)] leading-[var(--text-body-lg--line-height)] text-pretty max-w-2xl">
              {description}
            </div>
          ) : null}
        </div>
        {aside ? <div className="md:justify-self-end">{aside}</div> : null}
      </header>
      {children ? <div className="mt-12">{children}</div> : null}
    </Container>
  );
}
